/** 배차일보 운송구간 메모 · 컨테이너 배차 도착창고 메모 공통 UI 유틸 */

export const ROUTE_MEMO_POPUP_WIDTH = 300;
export const ROUTE_MEMO_VIEWPORT_MARGIN = 8;

export function estimateRouteMemoPopupHeight(text: string): number {
  const lines = text.split('\n');
  let wrappedLines = 0;
  for (const line of lines) {
    wrappedLines += Math.max(1, Math.ceil(line.length / 26));
  }
  wrappedLines = Math.max(wrappedLines, 1);
  const bodyHeight = Math.min(240, Math.max(36, wrappedLines * 20));
  return 10 + 22 + 6 + bodyHeight + 8 + 28 + 10;
}

export function computeRouteMemoHoverPosition(rect: DOMRect, text: string): { left: number; top: number } {
  const width = Math.min(ROUTE_MEMO_POPUP_WIDTH, window.innerWidth - ROUTE_MEMO_VIEWPORT_MARGIN * 2);
  const height = Math.min(
    estimateRouteMemoPopupHeight(text),
    window.innerHeight - ROUTE_MEMO_VIEWPORT_MARGIN * 2
  );

  let left = rect.right + 6;
  if (left + width > window.innerWidth - ROUTE_MEMO_VIEWPORT_MARGIN) {
    const leftOfCell = rect.left - width - 6;
    left = leftOfCell >= ROUTE_MEMO_VIEWPORT_MARGIN
      ? leftOfCell
      : Math.max(ROUTE_MEMO_VIEWPORT_MARGIN, window.innerWidth - width - ROUTE_MEMO_VIEWPORT_MARGIN);
  }

  let top = rect.top;
  if (top + height > window.innerHeight - ROUTE_MEMO_VIEWPORT_MARGIN) {
    top = rect.bottom - height;
  }
  top = Math.max(ROUTE_MEMO_VIEWPORT_MARGIN, top);
  if (top + height > window.innerHeight - ROUTE_MEMO_VIEWPORT_MARGIN) {
    top = Math.max(ROUTE_MEMO_VIEWPORT_MARGIN, window.innerHeight - height - ROUTE_MEMO_VIEWPORT_MARGIN);
  }

  return { left, top };
}
